<template>
  <div>
    <v-dialog v-model="open" persistent max-width="1000">
      <v-card>
        <v-card-title class="headline">{{ getTitle() }}</v-card-title>

        <v-card-text>
          <v-row v-if="showBtnAsociar()" class="mt-2">
            <v-col cols="6">
              <v-label><strong>Seleccione un comprobante para asociar</strong></v-label>
              <v-combobox
                :disabled="restanteAsociar() <= 0 || loading_spent"
                v-model="selected_spent"
                data-vv-as="Comprobante"
                name="spent_to_associate"
                :item-text="getItemName"
                item-value="id"
                :items="spents_available"
                label="Comprobantes disponibles"
                autocomplete="off"
                :loading="loading_spent"
                clearable
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No hay comprobantes disponibles para asociar
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
            <v-col v-if="item.is_credit_note" cols="3">
              <v-text-field
                v-model="imp_asoc"
                name="imp_asoc"
                label="Monto a asociar*"
                type="number"
                min="0"
                step="0.01"
                class="mt-6"
                autocomplete="off"
                :disabled="!isSelectedValid() || loading_associate"
                :error-messages="impAsocError ? [impAsocError] : []"
                :hint="isSelectedValid() ? 'Máximo: ' + formatUtils.formatPrice(maxAsociar()) : ''"
                persistent-hint
              />
            </v-col>
            <v-col :cols="item.is_credit_note ? 3 : 6" class="d-flex align-center">
              <v-btn
               small color="blue-grey" class="text-white mt-6"
                :disabled="!selected_spent || loading_associate || (item.is_credit_note && !!impAsocError)"
                :loading="loading_associate"
                @click="addItem"
              >
                <v-icon big color="green">add</v-icon>
                Agregar item
              </v-btn>    
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col>
              <v-chip v-if="item && item.is_credit_note" class="mx-1 my-3" color="primary" outlined pill>
                Total pendiente de imputar: ${{ new Intl.NumberFormat("es-ES").format(restanteAsociar()) }}
              </v-chip>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="list"
            :options="{
              descending: true,
              itemsPerPage: 15,
            }"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 15, 50, -1],
            }"
          >
            <template v-slot:item="props">
              <tr>
                <td>{{ getAsoc(props.item).cbte_fch }}</td>
                <td>{{ getAsoc(props.item).voucher_number_label }}</td>
                <td>{{ getEmitter(props.item) }}</td>
                <td>{{ getAsoc(props.item).receiver.name }}</td>
                <td>{{ getAsoc(props.item).mon_name }}</td>
                <td>{{ formatUtils.formatPrice(getTotal(props.item)) }}</td>
                <td>{{ formatUtils.formatPrice(getImputado(props.item)) }}</td>
                <td class="text-center">
                  <div v-if="can_disassociate">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small color="red" class="mr-2" @click="openDisassociate(props.item)"> close </v-icon>
                      </template>
                      <span>Desasociar</span>
                    </v-tooltip>
                  </div>
                </td>
              </tr>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                {{ "Busqueda sin resultados - " + search }}
              </v-alert>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="close()"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogYesNo
      :open="dialog_disassociate"
      nameCancel="Cancelar"
      nameAccept="Desasociar"
      title="Desasociar comprobante"
      message="¿Esta seguro que desea desasociar el comprobante?"
      @cancel="closeDisassociate"
      @accept="handleDisassociate"
      :maxWidth="500"
      :loading="loading_disassociate"
    />
  </div>
</template>
<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import { spentService } from "@/libs/ws/spentService";
import { vouchersService } from "@/libs/ws/vouchersService";
import DialogYesNo from "@/components/DialogYesNo";
export default {
  components: { DialogYesNo },
  props: {
    open: Boolean,
    cancel: Function,
    item: Object,
    can_disassociate: { type: Boolean, default: false },
    service: { type: Object, default: null },
    reload: { type: Function, default: null },
    isSpent: { type: Boolean, default: false },
    validator: Object,
  },
  data: () => ({
    formatUtils: formatUtils,
    vouchersService: vouchersService,
    list: [],
    headers: [
      { text: "Fecha", align: "left", sortable: true, value: "creation_date" },
      { text: "Nº Comprobante", align: "left", sortable: true, value: "voucher_number" },
      { text: "Emisor", align: "left", sortable: true, value: "emitter.name" },
      { text: "Receptor", align: "left", sortable: true, value: "receiver.name" },
      { text: "Moneda", align: "left", sortable: true, value: "mon_name" },
      { text: "Total del comprobante", align: "left", sortable: true, value: "imp_total" },
      { text: "Total imputado", align: "left", sortable: true, value: "imp_total" },
      { text: "Accion", align: "left" },
    ],
    dialog_disassociate: false,
    loading_disassociate: false,
    item_disassociate: null,
    spents_available: [],
    selected_spent: null,
    loading_spent: false,
    loading_associate: false,
    imp_asoc: null,
  }),
  created() {
    this.$validator = this.validator;
  },
  computed: {
    impAsocError() {
      if (!this.item || !this.item.is_credit_note || !this.isSelectedValid()) return null;
      const monto = parseFloat(this.imp_asoc);
      if (isNaN(monto) || monto <= 0) return "Ingrese un monto mayor a 0";
      if (!/^\d+(\.\d{1,2})?$/.test(String(this.imp_asoc))) return "El monto admite hasta 2 decimales";
      if (monto > this.maxAsociar()) return "El monto no puede superar " + formatUtils.formatPrice(this.maxAsociar());
      return null;
    },
  },
  watch: {
    selected_spent: function () {
      this.imp_asoc = this.isSelectedValid() ? this.maxAsociar() : null;
    },
    open: function (val) {
      if (val) {
        if (this.item.cbtes_asoc.length > 0) {
          this.list = this.item.cbtes_asoc;
        } else {
          this.list = [];
        }
        this.loadPendingSpents();
      } else {
        this.spents_available = [];
        this.selected_spent = null;
      }
    },
  },
  mounted() {},
  methods: {
    getItemName(item) {
      if (item.id === 0) {
        return this.isSpent ? item.spent_number_label : item.voucher_number_label;
      }
      
      const numberLabel = this.isSpent ? item.spent_number_label : item.voucher_number_label;
      const date = formatUtils.formatDateString(item.cbte_fch);
      const total = formatUtils.formatPrice(item.imp_total);
      
      const pendiente = formatUtils.formatPrice(this.getPendiente(item));

      return `${date} - ${numberLabel} - Total: ${total} - Pendiente: ${pendiente}`;
    },
    loadPendingSpents() {
      // Para Vouchers necesita emitter, para Spents necesita supplier
      if (!this.isSpent && (!this.item || !this.item.emitter)) {
        this.spents_available = [];
        return;
      }
      if (this.isSpent && (!this.item || !this.item.supplier)) {
        this.spents_available = [];
        return;
      }

      this.loading_spent = true;
      let params = []
      if(this.isSpent){
        params = { 
          supplier: this.item.supplier.id,
          receiver_id: this.item.receiver ? this.item.receiver.id : null
        };
      }else{
        params = { 
          emitter: this.item.emitter.id,
          receiver_id: this.item.receiver ? this.item.receiver.id : null
        };
      }

      if (this.item.receiver && this.item.receiver.id > 0) {
        params.receiver_id = this.item.receiver.id;
      }

      const serviceMethod = this.isSpent 
        ? spentService.getPendingSpents(params)
        : vouchersService.getPendingVouchers(params);

      serviceMethod
        .then((response) => {
          if (response.status) {
            // Filtrar los comprobantes que ya están asociados o que tienen otra moneda
            const associatedIds = this.item.cbtes_asoc.map((cbte) =>
              this.isSpent ? cbte.spent_asoc.id : cbte.voucher_asoc.id
            );
            this.spents_available = response.result.filter(
              (spent) => !associatedIds.includes(spent.id) && spent.mon_id == this.item.mon_id
            );
          } else {
            this.spents_available = [];
            this.$toast.error("Error al cargar comprobantes pendientes");
          }
        })
        .catch((e) => {
          console.log("getPendingSpents error", e);
          this.spents_available = [];
          this.$toast.error("Error al cargar comprobantes pendientes");
        })
        .finally(() => {
          this.loading_spent = false;
        });
    },
    addItem() {
      if (!this.selected_spent || this.selected_spent.id == 0) {
        this.$toast.error("Debe seleccionar un comprobante");
        return;
      }

      // Validar que quede monto pendiente de imputar
      const restante = this.restanteAsociar();
      if (restante <= 0) {
        this.$toast.error("No queda monto pendiente para asociar");
        this.selected_spent = null;
        return;
      }

      // Validar el monto a asociar (solo NC imputa saldo)
      if (this.item.is_credit_note && this.impAsocError) {
        this.$toast.error(this.impAsocError);
        return;
      }

      // Asociar el comprobante seleccionado
      this.loading_associate = true;
      
      this.service
        .associate(this.item.id, this.selected_spent.id, this.item.is_credit_note ? parseFloat(this.imp_asoc) : null)
        .then((response) => {
          if (response.status) {
            this.$toast.success("Comprobante asociado correctamente");
            
            // Actualizar la lista local
            this.list.push(response.result);
            this.item.cbtes_asoc = this.list;
            
            // Remover el comprobante de la lista de disponibles
            const index = this.spents_available.findIndex((s) => s.id === this.selected_spent.id);
            if (index > -1) {
              this.spents_available.splice(index, 1);
            }
            
            // Limpiar selección
            this.selected_spent = null;
            
            // Emitir reload para actualizar el componente padre
            this.$emit("reload");
          } else {
            this.$toast.error(response.msg || "Error al asociar el comprobante");
          }
        })
        .catch((e) => {
          console.log("associate error", e);
          this.$toast.error("Error al asociar el comprobante");
        })
        .finally(() => {
          this.loading_associate = false;
        });
    },
    getTotal(item) {
      const comprobante = this.getAsoc(item);
      if (comprobante != null) {
        return comprobante.mon_id == "PES" ? comprobante.imp_total : comprobante.total_usd;
      }
      return "-";
    },
    getImputado(item) {
      const comprobante = this.getAsoc(item);
      if (comprobante != null) {
        return comprobante.mon_id == "PES" ? item.imp_asoc : item.imp_asoc / comprobante.mon_cotiz;
      }
      return "-";
    },
    showBtnAsociar() {
      return (this.item && this.item.is_credit_note) || (this.item && this.item.is_debit_note && this.item.cbtes_asoc.length == 0);
    },
    restanteAsociar() {
      if (this.item == null) return 0;
      let total_asoc = 0;
      this.item.cbtes_asoc.forEach((element) => {
        total_asoc += parseFloat(element.imp_asoc);
      });

      //obtener el valor positivo del comprobante siempre
      let imp_total = Math.abs(parseFloat(this.item.imp_total));

      let total = imp_total - total_asoc;
      return total;
    },
    getPendiente(item) {
      return this.isSpent ? item.pending_to_paid : item.pending_to_charged;
    },
    isSelectedValid() {
      return this.selected_spent != null && typeof this.selected_spent === "object" && this.selected_spent.id > 0;
    },
    maxAsociar() {
      if (!this.isSelectedValid()) return 0;
      const pendiente = parseFloat(this.getPendiente(this.selected_spent));
      const max = Math.min(this.restanteAsociar(), isNaN(pendiente) ? 0 : pendiente);
      return Math.round(max * 100) / 100;
    },
    close() {
      this.$emit("cancel");
    },
    getAsoc(item) {
      if (!this.isSpent) return item.voucher_asoc;
      return item.spent_asoc;
    },
    getEmitter(item) {
      if (!this.isSpent) return item.voucher_asoc.emitter.name;
      return item.spent_asoc.supplier.name;
    },
    getTitle() {
      if (this.item != null) {
        const voucher = this.item.voucher_number != null ? this.item.voucher_number.toString().padStart(8, "0") : "-";
        return "Comprobantes asociados de " + this.item.voucher_number_label; //this.item.cbte_tipo_name + " - Nº " + this.item.pto_vta.toString().padStart(4,"0") + "-" + voucher;
      }
      return "";
    },
    openDisassociate(item) {
      this.item_disassociate = JSON.parse(JSON.stringify(item));
      this.dialog_disassociate = true;
    },
    closeDisassociate() {
      this.item_disassociate = null;
      this.dialog_disassociate = false;
    },
    handleDisassociate() {
      if (this.can_disassociate == false || this.service == null) return;

      if (this.item_disassociate != null) {
        // Guardar referencia antes de limpiar
        const itemToDisassociate = JSON.parse(JSON.stringify(this.item_disassociate));
        
        this.loading_disassociate = true;
        this.service
          .disassociate(
            this.isSpent ? itemToDisassociate.spent : itemToDisassociate.voucher, //*Ya es un ID
            this.getAsoc(itemToDisassociate).id
          )
          .then((response) => {
            if (response.status) {
              this.$toast.success("Comprobante desasociado correctamente");
              
              // Cerrar el dialog de confirmación
              this.item_disassociate = null;
              this.dialog_disassociate = false;
              
              // Recargar la lista de comprobantes asociados desde el item
              const disassociatedId = this.getAsoc(itemToDisassociate).id;
              const index = this.list.findIndex(item => this.getAsoc(item).id === disassociatedId);
              if (index > -1) {
                this.list.splice(index, 1);
              }
              this.item.cbtes_asoc = this.list;
              
              // Recargar comprobantes pendientes
              this.loadPendingSpents();
              
              // Emitir reload para actualizar el componente padre
              this.$emit("reload");
              
              // NO cerrar el modal principal - removido this.$emit("cancel")
            } else {
              this.$toast.error(response.msg);
            }
          })
          .catch((e) => {
            this.$toast.error("Error al desasociar el comprobante");
          })
          .finally(() => {
            this.loading_disassociate = false;
          });
      }
    },
  },
};
</script>
